import styled, { withTheme } from 'styled-components';
import ListItemIcon from './ListItemIcon';

const SeperatedListItemIcon = styled(ListItemIcon)`
  ${({ $standalone, theme }) => `
    border-left: 1px solid ${theme.palette.common.backgroundDark};

    ${theme.breakpoints.down('xs')} {
      min-height: ${$standalone ? 'none' : '42px'};
    }
  `}
`;

export default withTheme(SeperatedListItemIcon);
